import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Message from 'jl-design-system/components/message/Message';
import styles from './challenge-25.scss';

export class Challenge25 extends PureComponent {
  static propTypes = {
    isMessage: PropTypes.bool,
    isSignedIn: PropTypes.bool,
  };

  static defaultProps = {
    isMessage: false,
    isSignedIn: false,
  };

  render() {
    const {
      isSignedIn,
      isMessage,
    } = this.props;

    if (isMessage) {
      return (
        <Message
          body="It's our policy to ask for this if we think you look younger than 25."
          className={styles.message}
          title="Please provide proof that you're aged 18 or over upon delivery/collection of an age-restricted item, such as alcohol"
        />
      );
    }

    return (
      <div className={
        classNames(styles.container, {
          [styles.divider]: isSignedIn,
        })
      }
      >
        <h4>
          Please provide proof that you&apos;re aged 18 or over upon delivery/collection of an age-restricted item,
          such as alcohol
        </h4>
        <p>It&apos;s our policy to ask for this if we think you look younger than 25.</p>
      </div>
    );
  }
}

export default Challenge25;
